"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricCategoryKey = exports.MetricCategory = void 0;
var MetricCategory;
(function (MetricCategory) {
    MetricCategory["Attractiveness"] = "attractiveness";
    MetricCategory["ROI"] = "roi";
    MetricCategory["Performance"] = "performance";
    MetricCategory["Interaction"] = "interaction";
    MetricCategory["Heatmap"] = "heatmap";
    MetricCategory["Speed"] = "speed";
    MetricCategory["NRT"] = "nrt";
})(MetricCategory = exports.MetricCategory || (exports.MetricCategory = {}));
exports.MetricCategoryKey = {
    [MetricCategory.Attractiveness]: 'METRIC.TYPE.ATTRACTIVENESS',
    [MetricCategory.ROI]: 'METRIC.TYPE.ROI',
    [MetricCategory.Performance]: 'METRIC.TYPE.PERFORMANCE',
    [MetricCategory.Interaction]: 'METRIC.TYPE.INTERACTION',
    [MetricCategory.Heatmap]: 'METRIC.TYPE.HEATMAP',
    [MetricCategory.Speed]: 'METRIC.TYPE.SPEED',
    [MetricCategory.NRT]: 'METRIC.TYPE.NRT',
};
//# sourceMappingURL=metric-base.js.map